const LOGGER_QUERY_PARAM = 'debug_error'

class Logger {
  constructor (domain) {
    this.apiBaseUrl = 'https://api.' + domain
    this.fields = {}
    const d = (new Date())
    this.startedAt = d.getTime()
    console.debug('starting logger at ' + this._formatNumber(d.getUTCHours()) + ':' + this._formatNumber(d.getUTCMinutes()) + ':' + this._formatNumber(d.getUTCSeconds()) + '(UTC)')
  }
  setAuth (a) {
    this.a = a
  }
  _formatNumber (i) {
    return i < 10 ? '0' + i : i
  }
  async _sendRemote (level, msg, fields) {
    if (!this.a) return
    var data = {
      level: level,
      message: msg
    }
    if (fields) data.fields = fields
    try {
      return await this.a.sendWithApiKey({
        baseURL: this.apiBaseUrl,
        method: 'post',
        url: '/v1/logs',
        data: data
      })
    } catch (err) {
      return Promise.reject(err)
    }
  }
  _formatError (err) {
    return btoa(JSON.stringify({
      message: err.message,
      stack: err.stack
    }))
  }
  _parseError (err) {
    return JSON.parse(atob(err))
  }
  showDebugError () {
    const params = new URLSearchParams(window.location.search)
    if (!params.has(LOGGER_QUERY_PARAM)) return
    try {
      // + signs are replaced with spaces
      const err = this._parseError(params.get(LOGGER_QUERY_PARAM).replace(/ /g, '+'))
      var d = new Error(err.message)
      d.stack = err.stack
      console.error(d)
    } catch (err) {}
  }
  setFields (fields) {
    this.fields = fields
  }
  debug (id, msg, remote) {
    // Log to console
    console.debug('[' + ((Date.now() - this.startedAt) / 1000).toFixed(3) + '][' + id + '] ' + msg)

    // Send remote
    if (remote) {
      this._sendRemote('debug', '[' + id + '] ' + msg)
    }
  }
  error (err) {
    // No error
    if (!err) return

    // Get fields
    var fields = Object.assign({
      debug_url: window.location.origin + window.location.pathname + (window.location.search === '' ? '?' : window.location.search + '&') + encodeURI(LOGGER_QUERY_PARAM + '=' + this._formatError(err))
    }, this.fields)
    if (this.a) fields = Object.assign(this.a.loggerFields(), fields)

    // Log to console
    console.error(err)

    // Send remote
    return this._sendRemote('error', err.message, fields)
  }
}

export default Logger
